import {
  CancellationReasonDTO,
  ClubBean,
  ClubCommunicationPropertiesDTO,
  CustomPaymentCategoryDTO,
  FeatureFlags,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

const clubApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}`;
  return {
    findById(id: number) {
      return axiosInstance.get<ClubBean>(`club/${id}`);
    },
    featureFlags(clubId: number) {
      return axiosInstance.get<FeatureFlags>(`${clubPrefix}/feature-flags`);
    },
    details(clubId: number) {
      return axiosInstance.get<ClubBean>(`${clubPrefix}/details`);
    },
    getCommunicationProperties(clubId: number) {
      return axiosInstance.get<ClubCommunicationPropertiesDTO>(
        `${clubPrefix}/communication-properties`,
      );
    },
    updateCommunicationProperties(
      clubId: number,
      opts: ClubCommunicationPropertiesDTO,
    ) {
      return axiosInstance.patch(
        `${clubPrefix}/communication-properties`,
        opts,
      );
    },
    updateDetails(clubId: number, payload: Partial<ClubBean>) {
      return axiosInstance.patch<ClubBean>(`${clubPrefix}/details`, payload);
    },
    updateTerms(clubId: number, payload: FormData) {
      return axiosInstance.post<ClubBean>(
        `${clubPrefix}/details/terms-conditions`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    },
    stripeOnboardAccount(clubId: number) {
      return axiosInstance.put<string>(`${clubPrefix}/account/onboard-account`);
    },
    stripeSession(clubId: number) {
      return axiosInstance.get<string>(`${clubPrefix}/account/session`);
    },
    stripeCompleteOnboard() {
      return axiosInstance.put(`${clubPrefix}/account/onboard-account/status`);
    },
    customPaymentCategory(clubId: number) {
      return axiosInstance.get<CustomPaymentCategoryDTO[]>(
        `${clubPrefix}/custom-payment-category`,
      );
    },
    getCancellationReasonList(clubId: number) {
      return axiosInstance.get<CancellationReasonDTO[]>(
        `${clubPrefix}/cancellation-reason`,
      );
    },
    createCancellationReason({
      clubId,
      name,
    }: {
      clubId: number;
      name: string;
    }) {
      return axiosInstance.post(`${clubPrefix}/cancellation-reason`, { name });
    },
    deleteCancellationReason({
      clubId,
      reasonId,
    }: {
      clubId: number;
      reasonId: number;
    }) {
      return axiosInstance.delete(
        `${clubPrefix}/cancellation-reason/${reasonId}`,
      );
    },
    editCancellationReason({
      clubId,
      reasonId,
      name,
    }: {
      clubId: number;
      reasonId: number;
      name: string;
    }) {
      return axiosInstance.patch(
        `${clubPrefix}/cancellation-reason/${reasonId}`,
        { name },
      );
    },
  };
};

export default clubApi;
